import { useNavigate } from 'react-router-dom'

import { PaginatedResponse, RecordType } from '@factorialco/f0-react'
import { OneDataCollection, useDataCollectionSource } from '@factorialco/f0-react/dist/experimental'
import { ExternalLink } from '@factorialco/f0-react/icons/app'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

// We use DataCollection here to check if any cost centers exist before rendering
// the employee assignments list. This ensures consistent styling and automatic
// updates when DataCollection styles change. The empty state redirects users to
// create their first cost center, while the main collection displays employees
// with their cost center assignments (current and future).
export const EmptyCostCenters = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const source = useDataCollectionSource({
    dataAdapter: {
      fetchData: (): Promise<PaginatedResponse<RecordType>> => {
        return Promise.resolve({
          type: 'pages',
          records: [],
          total: 0,
          currentPage: 1,
          perPage: 10,
          pagesCount: 1,
        })
      },
      perPage: 10,
      paginationType: 'pages',
    },
    totalItemSummary: (totalCount: number) =>
      i18n.tp('finance.cost_center_people_list.count_employee_assignments', {
        count: totalCount,
      }),
  })

  return (
    <OneDataCollection
      source={source}
      visualizations={[{ type: 'table', options: { columns: [] } }]}
      emptyStates={{
        'no-data': {
          title: i18n.t('finance.cost_center_people_list.empty_cost_centers.title'),
          description: i18n.t('finance.cost_center_people_list.empty_cost_centers.description'),
          actions: [
            {
              label: i18n.t('finance.cost_center_people_list.empty_cost_centers.button'),
              onClick: () => {
                navigate(navigation.settings.finance.costCenters.list.fullPath())
              },
              variant: 'outline',
              icon: ExternalLink,
            },
          ],
        },
      }}
    />
  )
}
